<template>
    <v-card flat>
        <v-card-text class="pl-0 pr-0 pb-0">
            <v-row class="mt-n5">
                <v-col>
                    <tile-search-date
                        init-type="WEEK"
                        @changed="searchDateChanged"
                        @inited="searchDateInited"
                        ref="date_range_select"
                        :from-day="searchParam.search_start"
                        :to-day="searchParam.search_end"
                    ></tile-search-date>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selAnswerItems"
                        v-model="searchParam.answer_yn"
                        label="통화연결 선택"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col cols="2">
                    <v-select
                        class="text-h6"
                        single-line
                        :items="selSearchTypeItems"
                        v-model="searchParam.search_type"
                        label="검색 유형을 선택해 주세요"
                        item-text="txt"
                        item-value="val"
                    ></v-select>
                </v-col>
                <v-col>
                    <v-text-field
                        class="text-h6"
                        v-model="searchParam.search_text"
                        @keyup.enter="doSearch(1)"
                    ></v-text-field>
                </v-col>
                <v-col class="d-flex align-center">
                    <tile-search-button @click="doSearch(1)" class="mx-2" style="float:left;"></tile-search-button>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right mt-n5" style="font-size:20px; color:#555555;">통화량 : {{ this.$options.filters.number(totalCount) }} 건</v-col>
            </v-row>
            <v-card flat class="mt-4">
                <v-simple-table class="border-table">
                    <template v-slot:default>
                        <thead>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">접수일시</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">처리일시</th>
                            <th colspan="2" class="text-center text-h6 border-th-bottom">발신자</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">접수경로</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">응대콜리</th>
                            <th rowspan="2" class="text-center text-h6 border-th-bottom">처리상태</th>
                        </tr>
                        <tr style="background-color:#F4F6F8; height:39px; color:#333333; font-weight:600;">
                            <th class="text-center text-h6">이름(표시명)</th>
                            <th class="text-center text-h6">발신번호</th>
                        </tr>
                        </thead>
                        <tbody style="color:#555555;">
                        <tr v-for="(statItem, statIdx) in statList" style="height:68px;" :key="statIdx">
                            <td class="text-center" style="font-size:20px;">{{ statItem.reg_dt | dateMin }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.answer_dt | dateMin }}</td>
                            <td class="text-center" style="font-size:20px;">
                                <template v-if="statItem.cust_name && statItem.cust_name.length !== 0">{{ statItem.cust_name }}</template>
                                <template v-else>
                                    <v-btn outlined color="primary" @click="popupAddrBook(statItem.callback_mdn)">연락처 등록</v-btn>
                                </template>
                                <v-btn outlined color="primary" @click="popupCustMemo(statItem)" class="ml-3">메모({{ statItem.memo_count | number }})</v-btn>
                            </td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.callback_mdn | phoneNum }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.menu_name }}</td>
                            <td class="text-center" style="font-size:20px;">{{ statItem.answerer_name }}</td>
                            <td class="text-center" style="font-size:20px;">{{ answerText(statItem.answer_yn) }}</td>
                        </tr>
                        <tr style="height:69px;" v-if="!statList || statList.length === 0">
                            <td class="text-center" style="font-size:20px;" colspan="7">조회된 결과가 없습니다</td>
                        </tr>

                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
            <v-row class="mt-4">
                <v-col cols="2" class="text-left">
                    <v-btn v-on:click="downloadExcel" :loading="excelLoading">DOWNLOAD</v-btn>
                </v-col>
                <v-col cols="10" class="text-right">
                    <tile-paging :pageNo="searchParam.page_no" :totalPageCount="totalPageCount" @goPage="doSearch"></tile-paging>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import {mapState} from 'vuex'
import svcHistApi from '@/api/svc_hist'

export default {
    name: 'svc_hist_callback_list',
    components: {
        'TilePaging': () => import('@/components/common/tile_paging.vue'),
        'TileSearchDate': () => import('@/components/common/tile_search_date.vue'),
        'TileSearchButton': () => import('@/components/common/tile_search_button.vue'),
    },
    data: () => ({
        searchParam: {
            search_start: '',
            search_end: '',
            answer_yn: '',
            search_type: 'MENU_NAME',
            search_text: '',
            page_no: 1,
            page_size: 20
        },
        selAnswerItems: [
            {txt: '처리상태: 전체', val: ''},
            {txt: '처리상태: 접수', val: 'N'},
            {txt: '처리상태: 완료', val: 'Y'}
        ],
        selSearchTypeItems: [
            {txt: '검색유형: 접수경로', val: 'MENU_NAME'},
            {txt: '검색유형: 응대콜리', val: 'ANSWERER_NAME'},
        ],
        initFlags: {'search_date': false},
        excelLoading: false,
    }),
    created() {
        this.$store.commit('layoutFlag', true)
        this.$store.commit('menuId', 'svc_hist_callback')

        let lastMenuId = this.$store.getters['lastMenuId']
        if (lastMenuId === 'svc_hist_callback' && this.curSearchParam) {
            Object.assign(this.search, this.curSearchParam)
        }
    },
    computed: {
        ...mapState('svc_hist_callback', {
            curSearchParam: state => state.searchParam,
            totalCount: state => state.totalCount,
            statList: state => state.statList,
        }),
        totalPageCount() {
            if (this.totalCount === 0) {
                return 0
            }
            var pageSize = (this.searchParam && this.searchParam.page_size) ? this.searchParam.page_size : 25
            return Math.floor(this.totalCount / pageSize) + (((this.totalCount % pageSize) > 0) ? 1 : 0)
        },
        isLoaded() {
            return !!this.statList
        }
    },
    methods: {
        searchDateInited(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
            this.initFlags['search_date'] = true
            this.doSearch()
        },
        searchDateChanged(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
        },
        doSearch(no) {
            if (no) {
                this.searchParam.page_no = no
            }
            if (!this.initFlags.search_date) {
                return
            }

            this.$store.dispatch('svc_hist_callback/getStatList', {
                searchParam: this.searchParam,
                scb: () => {
                },
                fcb: () => {
                },
                va: this
            })
        },
        answerText(c) {
            if (c === 'Y') {
                return '처리완료'
            }
            return '접수'
        },
        downloadExcel() {
            this.excelLoading = true
            svcHistApi.downloadCallbackExcel(this.searchParam, () => {
                this.excelLoading = false
            }, () => {
                this.excelLoading = false
            }, this)
        },
        popupAddrBook(custMdn) {
            this.$store.dispatch('openAddrBook',
                {
                    'addrBook': {
                        'cust_mdn': custMdn,
                        'pageMode': 'add_with_mdn'
                    },
                    'okCb': (va) => {
                        va.doSearch()
                    },
                    'va': this
                }
            )
        },
        popupCustMemo(item) {
            this.$emit('open-memo', {'cust_seqno': item.cust_seqno, 'cust_mdn': item.callback_mdn, 'cust_name': item.cust_name})
        }
    }
}
</script>